<template>
    <!-- <div class="pageMenu">
        <Button icon="pi pi-fw pi-file" label="Projects" style="background-color: #00632c;"
            @click="showProject = !showProject"></Button>
        <Button v-if="showProject" icon="pi pi-folder-open" label="Open" @click="openProjectsMenu" />
        <Button v-if="showProject" icon="pi pi-pencil" label="Edit Project" @click="openEditProjectsMenu" />
        <Button icon="pi pi-box" label="Components" style="background-color: #00632c;"
            @click="showComponents = !showComponents"></Button>
        <Button v-if="showComponents" label="Equipment" @click="openEquipmentMenu">
            <img src="img/pme.png" class="button-icon" />
            <span class="ml-2 button-label">Equipment</span>
        </Button>
        <Button v-if="showComponents" @click="openReceiverMenu">
            <img src="img/nsr.png" class="button-icon" />
            <span class="ml-2 button-label">NSR Building</span>
        </Button>
        <Button v-if="showComponents">
            <img src="img/mitigation.png" class="button-icon" />
            <span class="ml-2 button-label">Mitigation</span>
        </Button>
    </div> -->
    <div class="pageMenu">
        <Button v-tooltip="'Open Project'" @click="openProjectsMenu" class="button1" aria-label="Open Project"
            :disabled="isPopupOpened">
            <i :class="opening" style="font-size: 1.5rem"></i>
        </Button>
        <Button v-tooltip="'Edit Project'" @click="openEditProjectsMenu" class="button2"
            :disabled="!hasCurrentProject || isPopupOpened" aria-label="Edit Project">
            <i class="pi pi-pencil" style="font-size: 1.5rem"></i>
        </Button>
        <Button label="Geographical Centre" @click="openCenterPointMenu" v-tooltip="'Geographical Centre'"
            class="button3" :disabled="!hasCurrentProject || isPopupOpened" aria-label="Geographical Centre">
            <i class="pi pi-circle" style="font-size: 0.7rem"></i>
        </Button>
        <Button label="Equipment" @click="openEquipmentMenu" v-tooltip="'Equipment'" class="button4"
            :disabled="!hasCurrentProject || isPopupOpened" aria-label="Equipment">
            <img src="img/pme.png" class="button-icon" alt="Equipment" />
        </Button>
        <loading v-model:active="isLoading" :can-cancel="canCancel" :on-cancel="whenCancelled" :is-full-page="fullPage"
            :height="height" :width="width" :color="color" :loader="loader" :background-color="bgColor">
            <template #default v-if="useSlot">
                <h3>Loading ...</h3>
            </template>
        </loading>
        <Button @click.prevent="openCalculationMenu" v-tooltip="'Calculate Noise'" class="button5"
            :disabled="!hasCurrentProject || isPopupOpened" aria-label="Calculate Noise">
            <img src="img/Calculation.png" class="button-icon" alt="Calculate Noise" />
        </Button>
        <Button label="Concurrent Sites" @click="openNeighborMenu" v-tooltip="'Concurrent Sites'" class="button6"
            :disabled="!hasCurrentProject || disabledBeforeCalculate || isPopupOpened" aria-label="Concurrent Sites">
            <i class="pi pi-building" style="font-size: 1.5rem"></i>
        </Button>
        <Button @click="openSelectionnMenu" v-tooltip="'Select NSR'" class="button7"
            :disabled="!hasCurrentProject || disabledBeforeCalculate || isPopupOpened" aria-label="Select NSR">
            <i class="pi pi-plus-circle" style="font-size: 1.5rem"></i>
        </Button>
        <!-- <Button @click="openSelectionnMenu" v-tooltip="'Notional Distance'" class="button8"
            :disabled="!hasCurrentProject">
            <i class="pi pi-plus-circle" style="font-size: 1.5rem"></i>
        </Button> -->
        <Button @click="confirmDirectToSelectNSR" v-tooltip="'Mitigation'" class="button8"
            :disabled="!hasCurrentProject || disabledBeforeCalculate || isPopupOpened" aria-label="Mitigation">
            <img src="img/mitigation.png" class="button-icon" alt="Mitigation" />
        </Button>
        <Button @click="openReport" v-tooltip="'Report'" class="button9"
            :disabled="!hasCurrentProject || disabledBeforeCalculate || isPopupOpened" aria-label="Report">
            <i class="pi pi-book" style="font-size: 1.5rem"></i>
        </Button>
        <Button @click="confirmApproveProject" v-tooltip="getApproveStatus" class="button10" v-if="!disabledApprove">
            <i class="pi pi-check-circle" style="font-size: 1.5rem"></i>
        </Button>
    </div>
    <ConfirmPopup></ConfirmPopup>
    <Dialog header="Reminder" v-model:visible="dialogDisplay" :modal="true">
        {{ dialogContent }}
        <template #footer>
            <Button :label="dialogButton" @click="navigate" autofocus />
        </template>
    </Dialog>
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js";
import DateHelper from '@/helper/DateHelper';
import { FALSE } from "ol/functions";
import { defineComponent } from 'vue'; //added by Alex
import Loading from '../index'; //added by Alex
import { store } from '../store/index'; //added by Alex

export default {
    name: 'LeftMenu',

    data() {

        return {
            // below Alex
            isLoading: false,
            fullPage: true,
            canCancel: true,
            useSlot: false,
            loader: 'bars',
            color: '#00632c',
            bgColor: '#ffffff',
            height: 128,
            width: 128,
            //above Alex
            opening: "pi pi-folder-open",
            showProject: true,
            showComponents: false,
            reject: false,
            dialogContent: "",
            dialogButton: "",
            dialogTarget: "",
            dialogDisplay: false,

            mitigationMessage: "",
            mitigationPage: 1
        }
    },

    //below Alex
    components: {
        Loading
    },
    //above Alex
    computed: {
        isPopupOpened() {
            return this.$route && this.$route.path && this.$route.path !== '/';
        },
        hasCurrentProject() {
            return this.$store.getters.currentProject?.id;
        },
        isReadonly() {
            return this.$store.getters.currentProject ? this.$store.getters.currentProject.readonly : false;
        },
        isContractor() {
            return this.$store.getters.currentUser ? this.$store.getters.currentUser.userType.includes('Contractor') : true;
        },
        getApproveStatus() {
            if (this.hasCurrentProject) {
                if (this.$store.getters.currentProject?.approved) {
                    return `Project Approved: ${this.$store.getters.currentProject.approvedDate}`;
                }
                else if (this.reject) {
                    return "Project has been rejected and waiting for resubmit";
                }
                else {
                    return "Approve Project";
                }
            }
            else {
                return "";
            }
        },
        disabledApprove() {
            if (this.hasCurrentProject && this.$store.getters.currentUser) {
                if (this.$store.getters.currentUser.userType.includes('Contractor')) {
                    return !this.$store.getters.currentProject.approved;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        },
        hasProjectInfoFilled() {
            return this.$store.getters.currentProject.projectTitle &&
                this.$store.getters.currentProject.submissionPurpose &&
                this.$store.getters.currentProject.proponent &&
                this.$store.getters.currentProject.agreement &&
                this.$store.getters.currentProject.mainContractor &&
                this.$store.getters.currentProject.engineerConsultant &&
                this.$store.getters.currentProject.bufferRadius
        },
        hasSelectedNSR() {
            console.log("currentProject", this.$store.getters.currentProject)
            return MapOL.getSelectedNSRPoints().length > 0;
        },
        hasMitigation() {
            let exceed = MapOL.getCalculationResultNSR().filter(c => c.ismitigated && Math.round(c.highestnoiselevel) > Math.round(c.noisecriteria)).length > 0;
            if (this.$store.getters.currentProject.equipments.filter(e => e.isQCM).length == 0 && !exceed) {
                this.mitigationMessage = "There is no Quieter Construction Methods applied to this project. Do you want to apply?";
                this.mitigationPage = 1;
                return false;;
            }
            else if (this.$store.getters.currentProject.equipments.filter(e => e.isQCM).length == 0 && exceed) {
                this.mitigationMessage = "There is no Quieter Construction Methods applied to this project. Do you want to apply?";
                this.mitigationPage = 1;
                return false;;
            }
            else if (this.$store.getters.currentProject.equipments.filter(e => !e.isQCM).length == 0 && exceed) {
                this.mitigationMessage = "There is no QPMEs applied to this project. Do you want to apply?";
                this.mitigationPage = 2;
                return false;
            }
            else if (this.$store.getters.currentProject.equipments.filter(e => e.isQCM).length > 0 && this.$store.getters.currentProject.equipments.filter(e => !e.isQCM).length > 0 && exceed) {
                this.mitigationMessage = "Do you want to apply further mitigation?";
                this.mitigationPage = 3;
                return false;
            }
            else
                return true;
        },
        disabledBeforeCalculate() {
            if (this.hasCurrentProject) {
                return !this.$store.getters.currentProject?.isCalculated
            }
            else return true;
        }
    },

    methods: {
        getProjectId() {
            return this.$store.getters.ProjectId;
        },
        openCenterPointMenu() {
            this.$router.push('/CenterPoint');
        },
        openNeighborMenu() {
            this.$router.push('/Neighbor');
        },
        openEquipmentMenu() {
            let props = this;
            this.checkSteps(2, function () {
                MapOL.prepareEquipmentTempLayers();
                props.$router.push('/Equipment');
            })
        },
        // openReceiverMenu() {
        //     this.$router.push('/NSR');
        // },
        openHome() {
            this.$router.push('/');
        },
        openProjectsMenu() {
            this.opening = "pi pi-spin pi-spinner";
            let user = this.$store.getters.currentUser;
            let props = this;
            props.getProjects(user.id, function (projects) {
                projects.forEach(p => {
                    p.opening = "pi pi-folder-open";
                    p.openingReadonly = "pi pi-eye";
                    p.deleting = "pi pi-trash";
                });
                props.$store.dispatch('setUserProjects', {
                    projects: projects
                });
                if (user.userType == "epd") {
                    props.getDistrictProjects(user.district.replace(/&/g, "%26"), function (districtProjects) {
                        districtProjects.forEach(p => {
                            p.opening = "pi pi-folder-open";
                            p.openingReadonly = "pi pi-eye";
                        });
                        props.$store.dispatch('setDistrictProjects', {
                            districtProjects: districtProjects
                        });
                        props.$router.replace({ path: '/Projects' });
                    })
                }
                else {
                    props.$router.replace({ path: '/Projects' });
                }
                props.opening = "pi pi-folder-open";
            })
        },
        getProjects(userId, successCallback) {
            this.axios
                .get(`${this.apiEndpoint}project?userId=${userId}`)
                .then(response => {
                    successCallback(response.data);
                })
                .catch(error => { console.log(error) })
        },
        getDistrictProjects(district, successCallback) {
            this.axios
                .get(`${this.apiEndpoint}project?district=${district}`)
                .then(response => {
                    successCallback(response.data);
                })
                .catch(error => { console.log(error) })
        },
        openEditProjectsMenu() {
            MapOL.prepareProjectTempLayers(this.$store.getters.currentProject.zones.length === 0);
            this.$router.push('/EditProjects');
        },
        openSelectionnMenu() {
            this.$router.push('/Select');
        },
        //below Alex Marvin
        openCalculationMenu() {
            this.isLoading = true;
            let props = this;
            this.checkSteps(3, function () {
                console.log("Calculating noise of project id: " + props.getProjectId());
                let calculateNoiseStart = new Date();
                MapOL.calculateNoise(props.$store.getters.currentProject);
                MapOL.hyun(props.$store.getters.currentProject);
                var jacob = MapOL.getIsCalculatedForVue2(props.$store.getters.currentProject);
                let timerId = setInterval(() => {
                    console.log("run every 2 seconds");
                    jacob = MapOL.getIsCalculatedForVue2(props.$store.getters.currentProject);
                    if (jacob == 1) {
                        clearInterval(timerId);
                        props.isLoading = false;
                        props.$store.getters.currentProject.isCalculated = 1;
                        let calculateNoiseEnd = new Date();
                        console.log(`calculate noise took ${(calculateNoiseEnd.getTime() - calculateNoiseStart.getTime()) / 1000} seconds`)
                    }
                }, 2000);
                //Unconditionally stop after 20 minutes: added by Alex Feb 22
                setTimeout(() => { clearInterval(timerId); props.isLoading = false; }, 1200000); // modified by Alex Feb 22
                return timerId;
            })
        },
        //above Alex Marvin
        //below Alex 
        whenCancelled() {
            clearTimeout();
            console.log("User cancelled the loader.")
        },
        //above Alex
        openReport(event) {
            if (!this.hasProjectInfoFilled) {
                if (!this.$store.getters.currentProject.readonly) {
                    let props = this;
                    this.$confirm.require({
                        target: event.currentTarget,
                        message: "Some mandatory fields in the project information are missing. Please complete them.",
                        icon: 'pi pi-info-circle',
                        accept: () => {
                            props.openEditProjectsMenu();
                        },
                        reject: () => { }
                    });
                }
                else {
                    this.openReportMenu();
                }
            }
            else if (!this.hasMitigation) {
                this.suggestMitigation(event)
            }
            else {
                this.openReportMenu();
            }
        },
        openReportMenu() {
            this.$router.push('/Report');
        },
        openMitigationMenu() {
            let props = this;
            this.checkSteps(3, function () {
                // if (props.$store.getters.currentProject.isCalculated == 0) {
                //     props.openCalculationMenu();
                // }
                MapOL.resetBuildingIdForMitigation();
                props.$router.push('/Mitigation/1');
            })
        },
        confirmDirectToSelectNSR(event) {
            let props = this;
            MapOL.setSelectedNSRPointsIDState();
            if (!MapOL.getSelectedNSRPointIds().length) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Select NSR before applying mitigation',
                    icon: 'pi pi-info-circle',
                    accept: () => {
                        props.openSelectionnMenu();
                    },
                    reject: () => {

                    }
                });
            }
            else {
                props.openMitigationMenu();
            }
        },
        confirmApproveProject(event) {
            let props = this;
            if (!props.$store.getters.currentProject?.approved) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Do you want to reveal this project? This project will be visable by other projects once revealed.',
                    icon: 'pi pi-info-circle',
                    rejectLabel: 'Reject',
                    acceptLabel: 'Reveal',
                    accept: () => {
                        props.approveProject();
                    },
                    reject: () => {
                        props.rejectProject();
                    }
                });
            }
        },
        approveProject() {
            let props = this;
            this.axios
                .post(`${this.apiEndpoint}project/approve?id=${this.getProjectId()}&approve=true`)
                .then(response => {
                    props.$store.getters.currentProject.approved = true;
                    props.$store.getters.currentProject.approvedDate = DateHelper.getDateString(Date.now());
                })
                .catch((error) => {

                })
        },
        rejectProject() {
            let props = this;
            this.axios
                .post(`${this.apiEndpoint}project/approve?id=${this.getProjectId()}&approve=false`)
                .then(response => {
                    props.reject = true;
                })
                .catch((error) => {
                })
        },
        suggestMitigation(event) {
            if (!this.$store.getters.currentProject.readonly) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: this.mitigationMessage,
                    icon: 'pi pi-info-circle',
                    accept: () => {
                        this.$router.push(`/Mitigation/${this.mitigationPage}`);
                    },
                    reject: () => {
                        this.openReportMenu();
                    }
                });
            }
            else {
                this.openReportMenu();
            }
        },
        checkSteps(step, success) {
            if (this.$store.getters.currentProject.zones.length == 0 && step > 0) {
                this.dialogContent = "There are no zones in this project. Please add zones and construction activities before assigning equipment."
                this.dialogButton = "Add Zone";
                this.dialogTarget = "/EditProjects?activeIndex=1";
                this.dialogDisplay = true;
                this.isLoading = false;
            }
            else if (this.$store.getters.currentProject.tasks.length == 0 && step > 1) {
                this.dialogContent = "There is no schedule in this project. Please add construction activities before assigning equipment."
                this.dialogButton = "Add Schedule";
                this.dialogTarget = "/EditProjects?activeIndex=2";
                this.dialogDisplay = true;
                this.isLoading = false;
            }
            else if (this.$store.getters.currentProject.equipments.length == 0 && step > 2) {
                this.dialogContent = "There are no equipment in this project. Please add equipment before calculating noise."
                this.dialogButton = "Add Equipment";
                this.dialogTarget = "/Equipment";
                this.dialogDisplay = true;
                this.isLoading = false;
            }
            else {
                success();
            }

        },
        navigate() {
            this.dialogDisplay = false;
            if (this.dialogTarget.includes("EditProjects")) {
                MapOL.prepareProjectTempLayers(this.$store.getters.currentProject.zones.length === 0);
            }
            this.$router.push(this.dialogTarget);
        },
    }
}
</script>

<style lang="less" scoped>
.pageMenu {

    position: fixed;
    // width: 200px;
    // height: calc(100vh - 70px);
    // background-color: #00632c;

    // .p-button {
    //     width: 100%;
    // }
    .p-button {
        width: 3.5rem;
        padding: 0.5rem 0;
        justify-content: center;
        height: 3.5rem;
    }

    .p-button.p-button-icon-only {
        width: 3.5rem;
    }

    .button1 {
        position: fixed;
        left: 10px;
        top: calc(70px + 0.5rem);
    }

    .button2 {
        position: fixed;
        left: 10px;
        top: calc(115px + 0.5rem);
    }

    .button3 {
        position: fixed;
        left: 10px;
        top: calc(175px + 0.5rem);
    }

    .button4 {
        position: fixed;
        left: 10px;
        top: calc(220px + 0.5rem);
    }

    .button5 {
        position: fixed;
        left: 10px;
        top: calc(265px + 0.5rem);
    }

    .button6 {
        position: fixed;
        left: 10px;
        top: calc(310px + 0.5rem);
    }

    .button7 {
        position: fixed;
        left: 10px;
        top: calc(355px + 0.5rem);
    }

    .button8 {
        position: fixed;
        left: 10px;
        top: calc(400px + 0.5rem);
    }

    .button9 {
        position: fixed;
        left: 10px;
        top: calc(445px + 0.5rem);
    }

    .button10 {
        position: fixed;
        left: 10px;
        top: calc(490px + 0.5rem);
    }

    .button11 {
        position: fixed;
        left: 10px;
        top: calc(535px + 0.5rem);
    }
}


.button-icon {
    width: 25px;
}

.button-label {
    text-align: center;
    width: 100%
}
</style>
